import React from "react"
import {connect} from "react-redux";

import DepositItem from "./DepositItem";
import {fetchDeposits} from "../../actions/depositActions";

import {Col, ListGroup, Row, Table} from 'reactstrap';
import Moment from "react-moment";

class DepositView extends React.Component {

  componentWillMount() {
    this.props.fetchDeposits()
  }

  render() {
    const { deposits, fetching, error } = this.props;

    const depoList = deposits.sort((a, b) => a.id < b.id).map(depot => <DepositItem key={depot.id} {...depot}/>)
    return <Row>
      <Col xs={8}>
        <h3>List of available deliveries</h3>
        <ListGroup>{depoList}</ListGroup>
      </Col>
      <Col>
        <h3>Recent deliveries</h3>
        <Table size="sm">
          <thead>
          <tr>
            <th>Delivery name</th>
            <th>Delivery date</th>
          </tr>
          </thead>
          <tbody>
          {deposits.sort((a, b) => a.id < b.id).map(depot => <tr key={depot.id}><td>{depot.name}</td><td><Moment fromNow date={depot.timestamp}/></td></tr>)}
          </tbody>
        </Table>
      </Col>
    </Row>
  }
}
const mapDispatchToProps = (dispatch) => ({
  fetchDeposits: () => dispatch(fetchDeposits())
})

const mapStateToProps = (state) => ({
  deposits: state.deposit.deposits,
  fetching: state.deposit.fetching,
  error: state.deposit.error,
})

export default connect(mapStateToProps, mapDispatchToProps)(DepositView)



// WEBPACK FOOTER //
// ./src/components/Deposits/DepositView.js